<script setup>
import { watch, ref } from 'vue';

const props = defineProps(['modelValue']);
const emit = defineEmits(['update:modelValue']);

const showPassword = ref(false);
const inputValue = ref(props.modelValue);

watch(
    () => props.modelValue,
    (newValue) => {
        inputValue.value = newValue;
    }
);

watch(inputValue, (newValue) => {
    emit('update:modelValue', newValue);
});
</script>

<template>
    <v-text-field
        v-model="inputValue"
        id="password"
        :append-inner-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
        :type="showPassword ? 'text' : 'password'"
        density="compact"
        variant="outlined"
        @click:append-inner="showPassword = !showPassword"
    ></v-text-field>
</template>
